import defaultLocale from "../../locale/en-US/index.js";
export default defaultLocale;
